import {Component, EventEmitter, Input, OnInit, Output, ViewChildren} from '@angular/core';
import {Session} from "../../../interfaces/session-data";
import {InitData} from "../../../interfaces/visa-src/InitData";
import {SrcProfileRequest} from "../../../interfaces/SrcProfileRequest";
import {SrcProfileReturns} from "../../../interfaces/visa-src/SrcProfileReturns";
import {MaskedCard} from "../../../interfaces/visa-src/MaskedCard";
import {IsRecognizedResponse} from "../../../interfaces/visa-src/IsRecognizedResponse";
import {InitiateResponseCard} from "../../../interfaces/card/responses/InitiateResponseCard";
import {ClickToPayService} from "../../../services/click-to-pay/click-to-pay.service";
import {SnackbarService} from "../../../services/snackbar-service/snackbar.service";
import { v4 as uuidv4 } from 'uuid';
import {Observable} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {PaymentMethodsOther} from "../../../interfaces/payment-methods";
import {MatIcon} from "@angular/material/icon";
import {MaskedData} from "../../../interfaces/visa-src/MaskedData";
import {environment} from "../../../../environments/environment";
import {InitiateIdentityValidationResponse} from "../../../interfaces/visa-src/initiateIdentityValidationResponse";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ConsumerIdentityResponse} from "../../../interfaces/visa-src/ConsumerIdentityResponse";
import IMask from "imask";
import {ConsumerIdentityRequest} from "../../../interfaces/visa-src/ConsumerIdentityRequest";
import {DirtyErrorStateMatcherDirective} from "../../../directives/dirty-error-state-matcher.directive";
import {CompleteIdentityValidationResponse} from "../../../interfaces/visa-src/CompleteIdentityValidationResponse";
import {CompleteIdentityValidationRequest} from "../../../interfaces/visa-src/CompleteIdentityValidationRequest";

@Component({
  selector: 'app-init-click-to-pay',
  templateUrl: './init-click-to-pay.component.html',
  styleUrls: ['./init-click-to-pay.component.scss']
})
export class InitClickToPayComponent implements OnInit {

  paymentMethodsOther: PaymentMethodsOther[] = [];
  @Input('cols') cols: number;
  @Input('mobile') mobile: boolean;
  @ViewChildren('matIconsOther') matIconsOther: [MatIcon];
  @Input('sessionData') sessionData: Session;
  paymentMethodsOtherTabsAmount: number;
  touch1 = {x: 0, y: 0, time: 0};
  selectedIndexOther = 0;
  // object per tab holder
  paymentMethodsOtherTabsObj = [];
  // 2D array containing values of each col
  paymentMethodsOtherTotalsArr = [];
  // loading vars
  public loading = true;
  public loadingSdk = true;
  public login = false;
  @Output()
  notify: EventEmitter<{}> = new EventEmitter<{ undefined }>();
  timer = 300;
  // Visa
  public otpSent: boolean = false;
  public srcProfilesReturned: boolean = false;
  public srcCardChosen: boolean = false;
  public addCardState: boolean = false;
  public recognizedSelectCardState: boolean = false;
  public checkoutCalled: boolean = false;
  private visaSrcSdk: any;
  private visaSrc: HTMLScriptElement;
  private visaSrcAdapter: HTMLScriptElement;

  public consumerPresent: boolean;
  public recognized: boolean;

  // Request, Response
  private initData: InitData;
  private srcProfileRequest: SrcProfileRequest;
  public srcProfileReturns: SrcProfileReturns;
  public selectedCard: MaskedCard;
  private isRecognizedResponse: IsRecognizedResponse;
  public initiateResponseCard: InitiateResponseCard;
  @Output() maskedDataEventEmitter = new EventEmitter<MaskedData>();
  maskedData: MaskedData;
  private initiateIdentityValidationResponse: InitiateIdentityValidationResponse;
  identityForm: FormGroup;
  otpForm: FormGroup;
  private consumerIdentityResponse: ConsumerIdentityResponse;
  private consumerIdentityRequest: ConsumerIdentityRequest;
  matcher = new DirtyErrorStateMatcherDirective();
  public headerColor = '';
  private completeIdentityValidationRequest: CompleteIdentityValidationRequest;

  constructor(
    private clickToPayService: ClickToPayService,
    private snackbarService: SnackbarService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBarService: SnackbarService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    this.createForm();
    this.headerColor = (document.getElementsByClassName('header-container')[0] as HTMLElement).style.backgroundColor;

    this.visaSrc = document.createElement('script');
    this.visaSrcAdapter = document.createElement('script');
    this.visaSrc.src = environment.visaSrcUrl;
    this.visaSrc.id = 'visa-src';
    document.body.appendChild(this.visaSrc);
    setTimeout(() => {
      this.visaSrcAdapter.innerHTML = 'let vSrcAdapter = window.vAdapters.VisaSRCI; let vSrc = new vSrcAdapter();';
      this.visaSrcAdapter.id = 'visa-src-adapter';
      document.body.appendChild(this.visaSrcAdapter);
      // tslint:disable-next-line:no-eval
      this.visaSrcSdk = eval('vSrc');
      console.log(this.visaSrcSdk);
      // Set up init param for SDK
      this.initData = {
        srciTransactionId: uuidv4(),
        srciDpaId: environment.srciDpaId,
        srcInitiatorId: environment.srcInitiatorId,
        dpaTransactionOptions: {
          transactionAmount: {
            transactionAmount: this.sessionData.sessionDisplayInformation.amount.toFixed(2),
            transactionCurrencyCode: this.sessionData.sessionDisplayInformation.currencyCode
          },
          transactionType: 'PURCHASE',
          dpaBillingPreference: 'POSTAL_COUNTRY',
          dpaShippingPreference: 'NONE',
        }
      };
      this.callInit();
    }, 1500);

    if (this.sessionData.sessionDisplayInformation.email && this.sessionData.sessionDisplayInformation.email.length > 0) {
      this.identityForm.controls.email.setValue(this.sessionData.sessionDisplayInformation.email);
    }

  }

  get emailControl() {
    return this.identityForm.get('email');
  }

  get verificationTypeControl() {
    return this.identityForm.get('verificationType');
  }

  get smsControl() {
    return this.identityForm.get('sms');
  }

  get otpControl() {
    return this.otpForm.get('otp');
  }

  createForm() {
    this.identityForm = this.fb.group({
      // verificationType: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]]
      //,
      // sms: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(14)]],
    });

    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    });
  }

  // Click to pay functions

  async getSrcProfile(input, cb): Promise<any> {
    const promiseData = await this.visaSrcSdk.getSrcProfile(input)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
    cb(promiseData);
  }

  callGetSrcProfile(srcProfileRequest: SrcProfileRequest): void {
    this.clickToPayService
      .auditSrcProfileRequest(srcProfileRequest, sessionStorage.getItem('sessionToken'))
      .subscribe(() => {

      });
    this.getSrcProfile(srcProfileRequest.idTokens, (result: SrcProfileReturns) => {
      console.log('SRC Profile Response', result);
      this.srcProfileReturns = result;
      this.identityForm.controls.email.setValue(this.srcProfileReturns.profiles[0].maskedConsumer.emailAddress);
      this.display(this.srcProfileReturns);
      this.clickToPayService
        .auditSrcProfileResponse(result, sessionStorage.getItem('sessionToken'))
        .subscribe(() => {

        });
      if (result.error) {
        console.error(result?.error);
        this.snackbarService.showSnackBar('Error retrieving user profile', result?.error.reason)
      }
      this.srcProfilesReturned = true;
      // Present the list of cards to user for selection
      // List of Cards -> result.profiles[0].maskedCards
    });
  }

  private async init(initParams: InitData, cb) {
    const promiseData = await
      this.visaSrcSdk.init(initParams)
        .then((response) => {
          console.log('Visa init success response', response);
          return response;
        })
        .catch((error) => {
          console.error('Visa init error response', error);
          this.snackbarService.showSnackBar('Error initializing Visa SDK');
          return error;
        });
    cb(promiseData);
  }

  private callInit(): void {
    this.init(this.initData, (result) => {
      console.log(result);
      this.clickToPayService
        .auditInitDataRequest(this.initData, sessionStorage.getItem('sessionToken'))
        .subscribe(() => {
          console.log('Audited init data');
        });
      if (!Object.keys(result).length) {
        console.log('init() successful response', result);
        // call isRecognized
        this.callIsRecognized();
      } else {
        console.log('init() failure response', result);
        console.error(result);
        this.display(this.srcProfileReturns);
        // Attempt if an email exists
        this.callIdentityLookup();
      }
    })
      .then((res) => {
        console.log('Result from promise return |', res);
      })
      .catch((err) => {
        console.log('Init failure catch |', err);
        this.snackbarService.showSnackBar('Error initializing Visa SDK');

      });
  }

  async isRecognized(cb) {
    const promiseData = await this.visaSrcSdk.isRecognized()
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
    cb(promiseData);
  }

  private callIsRecognized(): void {
    this.isRecognized((response: IsRecognizedResponse) => {
      console.log('is recognized response', response);
      this.isRecognizedResponse = response;
      this.clickToPayService
        .auditIsRecognizedResponse(this.isRecognizedResponse, sessionStorage.getItem('sessionToken'))
        .subscribe(() => {

        });
      if (response?.error) {
        this.display(this.srcProfileReturns);
        this.callIdentityLookup();
        this.snackbarService.showSnackBar(response?.error?.reason);
      }
      if (response.recognized) {
        // Store the token -> response.idTokens
        // User is recognized. Call getSrcProfile with tokens,
        // get masked card details, present in UI
        this.recognized = true;
        this.loadingSdk = false;
        this.recognizedSelectCardState = true;
        this.srcProfileRequest = {
          idTokens: this.isRecognizedResponse.idTokens
        };
        this.callGetSrcProfile(this.srcProfileRequest);
      } else {
        // User is not recognized -> Call identityLookup
        this.display(this.srcProfileReturns);
        this.callIdentityLookup();
      }

    });
  }

  onTabChanged(event) {
    let k = 0;
    this.selectedIndexOther = event.index;
    for (const elt of this.matIconsOther) {
      if (k === event.index) {
        (elt._elementRef.nativeElement as HTMLElement).textContent = 'lens';
      } else {
        (elt._elementRef.nativeElement as HTMLElement).textContent = 'trip_origin';
      }
      k++;
    }
  }

  page(event, direction: string, type: string) {
    // swipe or arrow press
    // perhaps in future add an if clause === 'other'

    if (type === 'swipe') {
      if (direction === 'right') {
        return this.selectedIndexOther <= this.paymentMethodsOtherTabsAmount - 1 && this.selectedIndexOther !== 0
          ?
          this.selectedIndexOther--
          :
          this.selectedIndexOther = this.paymentMethodsOtherTabsAmount - 1;
      } else {
        return this.selectedIndexOther < this.paymentMethodsOtherTabsAmount - 1
          ?
          this.selectedIndexOther++
          :
          this.selectedIndexOther = 0;
      }
    } else {
      if (direction === 'left') {
        return this.selectedIndexOther > this.paymentMethodsOtherTabsAmount - 1 ? this.selectedIndexOther++ : this.selectedIndexOther--;
      } else {
        return this.selectedIndexOther <= this.paymentMethodsOtherTabsAmount
          ?
          this.selectedIndexOther++
          :
          this.selectedIndexOther = 0;
      }
    }


  }

  display(srcProfileReturns: SrcProfileReturns) {
    console.log('Display!');
    if (srcProfileReturns?.profiles[0].maskedCards?.length > 0) {
      srcProfileReturns?.profiles[0]?.maskedCards
        .forEach(value => {
          this.paymentMethodsOther.push({
            imgUrl: value.digitalCardData.artUri,
            pan: `.... ${value.panLastFour}`,
            id: '0',
            code: `CLICK_TO_PAY_CARD_${srcProfileReturns?.profiles[0]?.maskedCards?.indexOf(value)}`,
            description: `CLICK_TO_PAY_CARD_${srcProfileReturns?.profiles[0]?.maskedCards?.indexOf(value)}`,
            lastModified: new Date(),
            paymentTypeName: 'CLICK_TO_PAY',
            maskedCard: value,
            srcProfileReturns: srcProfileReturns
          })
        });
    }
    this.paymentMethodsOtherTabsAmount = Math.ceil(this.paymentMethodsOther.length / this.cols);
    this.paymentMethodsOtherTabsObj = [];
    this.paymentMethodsOtherTotalsArr = [];

    for (const elt of this.paymentMethodsOther) {
      const lowercasedCode = elt.code.toLowerCase();
      // get img urls into obj
      if (elt.code === 'CLICK_TO_PAY') {
        elt.imgUrl = `../../../assets/icons/Payment_Cards/svg/image_${lowercasedCode}.png`;
        elt.backgroundImg = `url('../../../assets/icons/Payment_Cards/svg/card_${lowercasedCode}.png') center`;
      }
      // push into tabs obj and totalsArr
      this.paymentMethodsOtherTabsObj.push(elt);
      if (this.paymentMethodsOtherTabsObj.length === this.cols) {
        this.paymentMethodsOtherTotalsArr.push(this.paymentMethodsOtherTabsObj);
        this.paymentMethodsOtherTabsObj = [];
      } else if (
        this.paymentMethodsOtherTotalsArr.length === Math.floor(this.paymentMethodsOther.length / this.cols) &&
        this.paymentMethodsOtherTotalsArr.length * this.cols + this.paymentMethodsOtherTabsObj.length === this.paymentMethodsOther.length) {
        this.paymentMethodsOtherTotalsArr.push(this.paymentMethodsOtherTabsObj);
        this.paymentMethodsOtherTabsObj = [];
      }
    }
    this.loading = false;
    this.loadingSdk = false;
    this.maskedData = {
      visaSrcSdk: this.visaSrcSdk,
      initData: this.initData
    };
    this.maskedDataEventEmitter.emit(this.maskedData);
  }

  callCheckout(existing: string, paymentMethodOther: PaymentMethodsOther) {
    if (paymentMethodOther.code === 'CLICK_TO_PAY') {
      this.maskedData = {
        visaSrcSdk: this.visaSrcSdk,
        initData: this.initData
      }
      console.log('setting route state', this.maskedData);
      return this.router.navigate(['virtual/click_to_pay'], { state: { maskedData: this.maskedData } } );
    }
    this.maskedData = {
      maskedCard: paymentMethodOther.maskedCard,
      maskedProfile: paymentMethodOther.srcProfileReturns,
      isRecognizedResponse: this.isRecognizedResponse,
      loading: this.loading,
      loadingSdk: this.loadingSdk,
      recognized: this.recognized,
      recognizedSelectCardState: this.recognizedSelectCardState,
      srcProfileRequest: this.srcProfileRequest,
      srcProfileReturns: paymentMethodOther.srcProfileReturns,
      srcProfilesReturned: this.srcProfilesReturned,
      visaSrcSdk: this.visaSrcSdk,
      initData: this.initData
    };
    console.log('setting route state', this.maskedData);
    return this.router.navigate(['virtual/click_to_pay'], { state: { maskedData: this.maskedData } });
  }

  public resendOtp(): void {
    console.log('resend otp');
    this.callInitiateIdentityValidation();
    this.snackBarService.showSnackBar('Otp sent');
  }

  private callInitiateIdentityValidation() {
    this.initiateIdentityValidation( (result: InitiateIdentityValidationResponse) => {
      console.log('Identity Validation Initiation Response', result);
      this.clickToPayService
        .auditIdentityValidationResponse(result, sessionStorage.getItem('sessionToken'))
        .subscribe(() => {

        });
      this.otpSent = true;
      this.loading = false;
      if (result.maskedValidationChannel) {
        this.initiateIdentityValidationResponse = result;
        // Present UI and get the OTP from user
      }
      if (result?.error) {
        console.error(result?.error);
        this.snackBarService.showSnackBar('Error validating identity', result?.error.reason)
      }
    });
  }

  private async initiateIdentityValidation(cb) {
    const promiseData = await this.visaSrcSdk.initiateIdentityValidation()
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
    cb(promiseData);
  }

  async identityLookup(input, cb) {
    const promiseData = await this.visaSrcSdk.identityLookup(input)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
    cb(promiseData);
  }

  callIdentityLookup(): void {
    if (this.emailControl?.invalid) {
      this.emailControl.setErrors(Validators.required);
      return;
    }
    this.loading = true;
    this.consumerIdentityRequest = {
      // identityValue: this.verificationValueControl?.value,
      // type: this.verificationTypeControl?.value
      identityValue: this.emailControl?.value,
      identityProvider: 'SRC',
      type: 'EMAIL'
    };
    this.clickToPayService
      .auditIdentityLookupRequest(this.consumerIdentityRequest, sessionStorage.getItem('sessionToken'))
      .subscribe(() => {

      });
    this.identityLookup(this.consumerIdentityRequest, (result: ConsumerIdentityResponse) => {
      console.log('Identity Lookup Response', result);
      this.clickToPayService
        .auditIdentityLookupResponse(result, sessionStorage.getItem('sessionToken'))
        .subscribe(() => {

        });
      this.consumerIdentityResponse = result;
      if (result.error) {
        console.error(result.error)
        this.snackBarService.showSnackBar('Identity lookup failed', result.error.reason);
        this.loading = false;
      }
      if (result.consumerPresent) {
        // Consumer present -> call initiateIdentityValidation
        this.loading = true;
        this.otpForm = this.fb.group({
          otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
        });
        this.consumerPresent = true;
        this.callInitiateIdentityValidation();
      } else {
        console.log('Consumer is not present!');
        this.consumerPresent = false;
        this.loading = false;
      }
    });
  }

  callCompleteIdValidationClicked(){
    this.loading = true;
    this.callCompleteIdValidation(this.otpControl?.value);
  }

  async completeIdentityValidation(input: CompleteIdentityValidationRequest, cb) {
    console.log('Input data!', input);
    const promiseData = await this.visaSrcSdk.completeIdentityValidation(input.validationData)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
    cb(promiseData);
  }

  callCompleteIdValidation(otp) {
    this.completeIdentityValidationRequest = {
      validationData: otp
    };
    this.clickToPayService
      .auditCompleteIdentityValidationRequest(this.completeIdentityValidationRequest, sessionStorage.getItem('sessionToken'))
      .subscribe(() => {

      });
    this.completeIdentityValidation(this.completeIdentityValidationRequest, (result: CompleteIdentityValidationResponse) => {
      console.log('Identity validation result', result);
      this.clickToPayService
        .auditCompleteIdentityValidationResponse(result, sessionStorage.getItem('sessionToken'))
        .subscribe(() => {

        });
      if (!result.error){
        // Store the token -> result.idToken
        // call getSrcProfile with tokens,
        // get masked card details, present in UI
        const idTokens = []; // Or get previous idTokens array, if any
        idTokens.push((result).idToken);
        this.srcProfileRequest = {
          idTokens: idTokens
        };
        this.callGetSrcProfile(this.srcProfileRequest);
      } else {
        // validation error
        this.loading = false;
        if (result.error.reason === 'CODE_INVALID') {
          this.snackBarService
            .showSnackBar('Invalid code entered, please try again');
        } else if (result.error.reason === 'CODE_EXPIRED') {
          this.snackBarService
            .showSnackBar('Code has expired, please re-send otp and try again');
        } else if (result.error.reason === 'RETRIES_EXCEEDED') {
          this.snackBarService
            .showSnackBar('Your retries have been exceeded');
        }
        console.error('Error occurred', result);
      }
    });
  }

  public changeConsumerIdentity(): void {
    console.log('Change consumer identity');
    this.otpSent = false;
    this.srcProfilesReturned = false;
    this.srcCardChosen = false;
    this.addCardState = false;
    this.recognizedSelectCardState = false;
    this.checkoutCalled = false;
  }

}
